module.exports = __webpack_public_path__ + "img/nfe.f2143473.svg";